// extracted by mini-css-extract-plugin
module.exports = {"block":"J7u5R","container":"mDz45","wrapper":"RMol4","content":"AMmn5","title":"NEvgh","subtitle":"RUDYN","tel":"l1oY7","link":"AW4Sm","partners":"aE32v","partnerLink":"wwIX4"};